import { render, staticRenderFns } from "./GradientBox.vue?vue&type=template&id=62d2c92b&scoped=true&"
import script from "./GradientBox.vue?vue&type=script&lang=js&"
export * from "./GradientBox.vue?vue&type=script&lang=js&"
import style0 from "./GradientBox.vue?vue&type=style&index=0&id=62d2c92b&prod&lang=scss&"
import style1 from "./GradientBox.vue?vue&type=style&index=1&id=62d2c92b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2c92b",
  null
  
)

export default component.exports